const passwordCheck = (password) => {
    //longer than 8 char , has uppercase , has lowercase , has number , has any non word character
    if(password.length >= 8 && /[A-Z]/.test(password) && /[a-z]/.test(password) && /[0-9]/.test(password) && /[\W]/.test(password)) return true;
    return false;
}

export default passwordCheck